import(/* webpackMode: "eager" */ "/home/runner/work/payments-platform-web-app/payments-platform-web-app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/payments-platform-web-app/payments-platform-web-app/src/app/_components/aws-amplify/ConfigureAmplifyClientSide.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/runner/work/payments-platform-web-app/payments-platform-web-app/src/app/(auth)/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/payments-platform-web-app/payments-platform-web-app/src/app/(auth)/SessionManager.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/payments-platform-web-app/payments-platform-web-app/src/styles.css");
